import { INVALIDATE_USERS } from 'actions/invalidationTags';
import { ApiMananger } from "actions/rtkquery";
import {
    ACTIVATION_API_ROUTE,
    LOGIN_API_ROUTE,
    REGISTER_API_ROUTE,
    RESET_PASSWORD_API_ROUTE,
    RESET_PASSWORD_CONFIRM_API_ROUTE,
    MFA_STATUS_API_ROUTE,
    MFA_SETUP_API_ROUTE,
    MFA_ENABLE_API_ROUTE,
    MFA_DISABLE_API_ROUTE,
    MFA_REGENERATE_BACKUP_CODES_API_ROUTE,
    MFA_VERIFY_LOGIN_API_ROUTE,
    MFA_SEND_EMAIL_CODE_API_ROUTE,
} from "routes/api/endpoints";

const userApi = ApiMananger.injectEndpoints({
    endpoints: (build) => ({
        loginUser: build.mutation({
            query(body) {
                return {
                    url: LOGIN_API_ROUTE,
                    method: "POST",
                    body,
                };
            },
            invalidatesTags: [INVALIDATE_USERS],
        }),
        registerUser: build.mutation({
            query(body) {
                return {
                    url: REGISTER_API_ROUTE,
                    method: "POST",
                    body,
                };
            },
            invalidatesTags: [INVALIDATE_USERS],
        }),
        activationUser: build.mutation({
            query(body) {
                return {
                    url: ACTIVATION_API_ROUTE,
                    method: "POST",
                    body,
                };
            },
            invalidatesTags: [INVALIDATE_USERS],
        }),

        forgetPassword: build.mutation({
            query(body) {
                return {
                    url: "API.USER_API.FORGET_PASSWORD()",
                    method: "POST",
                    body,
                };
            },
            invalidatesTags: [INVALIDATE_USERS],
        }),
        otpVerification: build.mutation({
            query(body) {
                return {
                    url: "API.USER_API.OTP_VERIFICATION()",
                    method: "POST",
                    body,
                };
            },
            invalidatesTags: [INVALIDATE_USERS],
        }),
        resetPassword: build.mutation({
            query(body) {
                return {
                    url: RESET_PASSWORD_API_ROUTE,
                    method: "POST",
                    body,
                };
            },
            invalidatesTags: [INVALIDATE_USERS],
        }),
        resetPasswordConfirm: build.mutation({
            query(body) {
                return {
                    url: RESET_PASSWORD_CONFIRM_API_ROUTE,
                    method: "POST",
                    body,
                };
            },
            invalidatesTags: [INVALIDATE_USERS],
        }),
        updatePassword: build.mutation({
            query(body) {
                return {
                    url: "",
                    method: "PUT",
                    body,
                };
            },
            invalidatesTags: [INVALIDATE_USERS],
        }),

        // Authentification multifacteur (MFA / 2FA)
        getMfaStatus: build.query({
            query: () => ({
                url: MFA_STATUS_API_ROUTE,
                method: "GET",
            }),
            providesTags: [INVALIDATE_USERS],
        }),
        setupMfa: build.mutation({
            query: () => ({
                url: MFA_SETUP_API_ROUTE,
                method: "POST",
            }),
        }),
        enableMfa: build.mutation({
            query: (body) => ({
                url: MFA_ENABLE_API_ROUTE,
                method: "POST",
                body,
            }),
            invalidatesTags: [INVALIDATE_USERS],
        }),
        disableMfa: build.mutation({
            query: (body) => ({
                url: MFA_DISABLE_API_ROUTE,
                method: "POST",
                body,
            }),
            invalidatesTags: [INVALIDATE_USERS],
        }),
        regenerateBackupCodes: build.mutation({
            query: (body) => ({
                url: MFA_REGENERATE_BACKUP_CODES_API_ROUTE,
                method: "POST",
                body,
            }),
            invalidatesTags: [INVALIDATE_USERS],
        }),
        verifyMfaLogin: build.mutation({
            query: (body) => ({
                url: MFA_VERIFY_LOGIN_API_ROUTE,
                method: "POST",
                body,
            }),
            invalidatesTags: [INVALIDATE_USERS],
        }),
        sendMfaEmailCode: build.mutation({
            query: (body) => ({
                url: MFA_SEND_EMAIL_CODE_API_ROUTE,
                method: "POST",
                body,
            }),
        }),
    }),
});

export const {
    useLoginUserMutation,
    useRegisterUserMutation,
    useActivationUserMutation,
    useResetPasswordConfirmMutation,
    useResetPasswordMutation,

    useUpdatePasswordMutation,
    useForgetPasswordMutation,
    useOtpVerificationMutation,

    useGetMfaStatusQuery,
    useSetupMfaMutation,
    useEnableMfaMutation,
    useDisableMfaMutation,
    useRegenerateBackupCodesMutation,
    useVerifyMfaLoginMutation,
    useSendMfaEmailCodeMutation,
} = userApi;